import React, { useState, useEffect, useRef } from 'react';
import {Button } from "reactstrap";

import MapPicker from 'react-google-map-picker'

//import Navbar from '../Navbar/Navbar';
import Navbar from '../Navbar/Navbar_00';
import Breadcrumb from '../Breadcrumb/Breadcrumb';
import Footer from "../Footer/Footer_00";

import Loader from '../../../loader';

import './Forms.css';
//import parse from 'html-react-parser';

import * as Hosts from '../../../Hosts';
import {
    // set_language,
    reqGET,
	//reqPOST,
    //repo_banner_link,
    translate,
    content_language,
    functionSendMail,
    simpleAxiosGet

} from '../../../Utils';

import { language } from '../WEBContent/Language';

import Swal from 'sweetalert2';

const ContactFormMap = (props) => {

    const [ , set_dados ] = useState( null )
	const dados_config = useRef({})

    const navbar_interface = {
        id: '',
        info: {},
        content: {
            childs: []
        }
    }
    const navbar = useRef(navbar_interface)

    const content_interface = {
        id: '',
        info: {},
        content: {}
    }
    const content = useRef(content_interface)

    const data_interface = {
        id: '',
        info: {
            companycode: Hosts.companycode,
            name: '',
            email: '',
            subject: '',
            message: '',
            rgpd: false,    
        }

    }
    const dados = useRef( data_interface )

    const [lang, set_lang] = useState('pt')
    const [lang_id, set_lang_id] = useState('1')

    const [isloading, setLoading] = useState(true)

    // MAPA
	const gmaps_key = useRef({})
	const gmaps_georeverse_key = useRef({})
	const location_name = useRef([])
    const [defaultLocation, setDefaultLocation] = useState({});

    const [location, setLocation] = useState({});
    const [zoom, setZoom] = useState(18);

    const handleChangeLocation = async (lat, lng) => {
        setLocation({lat: lat, lng: lng});

        let aux_georeverse = await simpleAxiosGet('https://maps.googleapis.com', '/maps/api/geocode/json?latlng=' + lat + ',' + lng + '&key=' + gmaps_georeverse_key.current)
        // console.log('aux_georeverse', aux_georeverse)
        // console.log('aux_georeverse.results', aux_georeverse.results)
        if(aux_georeverse?.results !== undefined && aux_georeverse?.results !== null && Array.isArray(aux_georeverse.results) && aux_georeverse.results.length > 0) {
            set_dados(location_name.current = aux_georeverse.results[0])
        }

    }
    
    function handleChangeZoom (newZoom){
        setZoom(newZoom);
    }
    // MAPA

    useEffect(() => { 

        (async () => {

            let aux_location = {
                lat: 10, 
                lng: 16
            }
            
            let aux_settings = await reqGET(`${Hosts.SIMCore_API}/web/config/attributes/type/${Hosts.companycode}/website_settings`) 
            if(aux_settings.data !== undefined && aux_settings.data !== null && aux_settings.data.length > 0) {
                set_dados(gmaps_key.current = aux_settings.data[0].info.settings.gmaps_key)
                set_dados(gmaps_georeverse_key.current = aux_settings.data[0].info.settings.gmaps_georeverse_key)
            }

            if(props.info !== undefined && props.info !== null && props.info !== '') {
                set_dados(dados_config.current = props.info.state.dados_config)
                set_dados(navbar.current = props.info.state.dados_navbar)
                set_dados(content.current = props.info.state.dados_content)

                if(dados_config.current.content[0].contacts.gps !== undefined && dados_config.current.content[0].contacts.gps.lat !== '' && dados_config.current.content[0].contacts.gps.lng !== '') {

                    aux_location = {
                        lat: parseFloat(dados_config.current.content[0].contacts.gps.lat), 
                        lng: parseFloat(dados_config.current.content[0].contacts.gps.lng)
                    }
                }

            }
            setDefaultLocation(aux_location)
            await handleChangeLocation(aux_location.lat, aux_location.lng)
            // setLocation(aux_location)

            try {

                set_lang(localStorage.getItem('lang'))
                content_language.forEach(el => {
                    if (el.code === localStorage.getItem('lang')) {
                        set_lang_id(el.id)
                    }
                })

                setLoading(false)

                return

            } catch {
                console.log('nada')

                return
            }
        })()
    
    }, [props]); 

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const [counterText, setCounterText] = useState('');

    const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handle_change_info_textarea = (e) => {
        const { name, value } = e.target;
        //console.log('NAME ', name)
        //console.log('VALUE ', value)
        setCounterText(e.target.value)

        set_dados(dados.current.info[name] = value)
        //set_dados(dados.current.info.date.creation = new Date())
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handleSubmit = async e => {
        e.preventDefault();

        let contact_email_form = (dados_config.current.content !== undefined && dados_config.current.content[0]?.contacts !== undefined && dados_config.current.content[0]?.contacts?.email_form !== undefined && dados_config.current.content[0]?.contacts?.email_form !== '' ? dados_config.current.content[0]?.contacts?.email_form : Hosts.contactSendToCC );
        let company_name = (dados_config.current.content !== undefined && dados_config.current.content[0]?.title !== undefined && dados_config.current.content[0]?.title !== '' ? translate(dados_config.current.content[0].title, lang) : Hosts.webSiteTitle);

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].contact_form +':</h4>'+
                        '<span><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + dados.current.info.email + '</label></span>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].subject +': </b><label>' + dados.current.info.subject + '</label></span>' +
                        '<br/>'+
                        '<br/>' +
                        '<span><b>'+ language[lang].message +': </b><label>' + dados.current.info.message + '</label></span>' +
                        '<br/>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].adress +': </b><label>' + location_name.current.formatted_address + '</label></span>' +
                        '<br/>'+
                        '<span><b>Lat: </b><label>' + location.lat + '</label></span>' +
                        '<br/>'+
                        '<span><b>Lng: </b><label>' + location.lng + '</label></span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        functionSendMail(Hosts.contactFrom, [dados.current.info.email], [contact_email_form], company_name + ' - ' + language[lang].contact_form, mail_content, [], dados_config.current)
            .then((res) => {
                if(res === true) {
                    set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                    document.getElementById('agree').checked = false
                    setAgree(false)
                    //setRefresh(refresh + 1)
                    Swal.fire({
                        title: language[lang].contact_form,
                        text: language[lang].sent_successfully,
                        icon: 'success',
                        //showCancelButton: true,
                        confirmButtonColor: '#08396a',
                        //confirmButtonText: 'Tentar novamente',
                        })
                }
                else {
                    console.log('erro')
                }
            })

    }
        
    return (isloading ?
		<Loader />
    :
        <>
            <Navbar dados_config={dados_config.current} dados_navbar={navbar.current} />
            <Breadcrumb dados_config={dados_config.current} dados_navbar={navbar.current} dados_content={content.current} />
            <main className="contacts">
                <div className="container my-5">
                    <div className="row">
                        <div className="col-12 col-md-5">
                            <div className='info-container'>
                                <h1 className="titulo-secundario mb-3">
                                    {language[lang].choose_adress}
                                </h1>
                                <div className='flex-align-items mb-3'>
                                    <>
                                        <div className=''>
                                            <strong>
                                                {language[lang].adress}
                                            </strong>
                                            <p>
                                                {location_name?.current?.formatted_address ? location_name.current.formatted_address : ''}
                                            </p>
                                        </div>
                                        
                                        <MapPicker 
                                            defaultLocation={defaultLocation}
                                            zoom={zoom}
                                            mapTypeId="satellite"
                                            style={{height:'400px'}}
                                            onChangeLocation={handleChangeLocation} 
                                            onChangeZoom={handleChangeZoom}
                                            apiKey={gmaps_key.current}
                                        />
                                    </>

                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-7 mt-5 mt-md-0">
                            <form className='form-container' onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        {language[lang].read_terms_conditions}
                                        {/*Leia os nossos <a href={Hosts.WEB_SITE_URI + "terms_conditions"} target="_blank" rel="noreferrer">termos e condições</a> antes de submeter o formulário. Ao submeter concorda com os termos do nosso serviço.*/}
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="name">{language[lang].name}*</label>
                                        <input id="name" type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].name + " *"} onChange={handle_change_info} required />
                                    </div>
                                    <div className="col-12 col-sm-6 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="email">{language[lang].email}*</label>
                                        <input id="email" type="email" name="email" 
                                            value={dados.current.info.email} 
                                            className="form-control" 
                                            placeholder={language[lang].email + " *"} 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>

                                    <div className="col-12 mb-3">
                                        <label className="form-label visually-hidden" htmlFor="subject">{language[lang].subject}*</label>
                                        <input id="subject" type="subject" name="subject" 
                                            value={dados.current.info.subject} 
                                            className="form-control" 
                                            placeholder={language[lang].subject + " *"} 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>
                                    <div className="col-12">
                                        <label className="form-label visually-hidden" htmlFor="message">{language[lang].message}*</label>
                                        <textarea
                                            style={{ height: "180px", width: "100%" }}
                                            id="message"
                                            name="message"
                                            className="form-control"
                                            placeholder={language[lang].message + " *"}
                                            maxLength="600"
                                            value={dados.current.info.message}
                                            onChange={handle_change_info_textarea}
                                            required
                                        />
                                        <div className="text-end fw-bold my-2 small">
                                            {language[lang].maximum_numbers_of_caracters}&#58;&nbsp;{counterText.length}/600
                                        </div>
                                        {/* <TextareaCounter countLimit={200} style={{height: "100px", width: "100%"}} id="message" name="message" value={dados.current.info.message} onChange={handle_change_info} required/>
                                        <input type="text" name="message" value={dados.current.info.message} className="form-control form-control-sm" placeholder="" onChange={handle_change_info} /> */}
                                    </div>

                                    <div className="col-12">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)}/>
                                            <label className="form-check-label small" htmlFor="agree">{language[lang].agree_terms_conditions}</label>&nbsp;
                                            {
                                                lang !== 'pt' && dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms[lang_id] !== undefined && dados_config.current.content[0]?.terms[lang_id] !== null && dados_config.current.content[0]?.terms[lang_id] !== '' ?
                                                    <a className="small" href={dados_config.current.content[0]?.terms[lang_id]?.link} target="_blank" rel="noreferrer">
                                                        {language[lang].terms_conditions_link}
                                                    </a>
                                                :
                                                    dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms['1'] !== null && dados_config.current.content[0]?.terms['1'] !== '' ?
                                                        <a className="small" href={dados_config.current.content[0]?.terms['1']?.link} target="_blank" rel="noreferrer">
                                                            {language[lang].terms_conditions_link}
                                                        </a>
                                                    :
                                                        <a className="small pe-none" href='!#' target="_blank" rel="noreferrer">
                                                            {language[lang].terms_conditions_link}
                                                        </a>
                                            }
                                            {/*<a className="small" href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>*/}
                                        </div>
                                        <div className="small">{language[lang].terms_conditions_required}</div>
                                    </div>

                                    <div className='col-12 text-end mt-5'>
                                        {/*{console.log('AGREE2', agree)}
                                        {console.log('MAIL: ', JSON.stringify(mailOptions))}*/}
                                        <Button disabled={!agree} className="mx-auto" color="primary">{language[lang].send}</Button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

            </main>
            <Footer dados_config={dados_config.current} dados_navbar={navbar.current} />
        </>
    )

};

export default ContactFormMap;